// extracted by mini-css-extract-plugin
module.exports = {"wrapperFilter":"ModalFormBagging_wrapperFilter__2UP2q","filterColumn":"ModalFormBagging_filterColumn__1afHC","actionFilter":"ModalFormBagging_actionFilter__3r0aq"};